/// <reference types="zustand/middleware/immer" />
/// <reference types="zustand/middleware/subscribeWithSelector" />

import { createStore as createZustandStore } from "zustand";
import type { StoreApi, UseBoundStore } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import { immer } from 'zustand/middleware/immer';

import {
  StoreSlice,
  SetStoreSlice,
  SetState,
  GetState,
  SetInitialState,
  Write,
  WithImmer,
} from "./types";

// slices
import createAppSlice from "./slices/createAppSlice";
import createGlobalsSlice from "./slices/createGlobalsSlice";
import createLocaleSlice from "./slices/createLocaleSlice";
import createGameSlice from "./slices/createGameSlice";
import createGlobalPlayPauseSeekSlice from "./slices/createGlobalPlayPauseSeekSlice";
import createA11ySlice from "./slices/createA11ySlice";
import createTextOverlaySlice from "./slices/createTextOverlaySlice";
import createPowerupSlice from "./slices/createPowerupSlice";
import createSettingsPanelSlice from "./slices/createSettingsPanelSlice";
import createPlayCanvasSlice from "./slices/createPlayCanvasSlice";
import createToySlice from "./slices/createToySlice";
import createCameraSlice from "./slices/createCameraSlice";

const setInitialState: SetInitialState<any> =
  (type: any, initialState: any) => (set: SetState<any>) =>
    set((state: any) => {
      state[type] = initialState;
    });

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const setStoreSlice:SetStoreSlice<any> = (slice:StoreSlice<any>) => (set: SetState<any>, get: GetState<any>) => set((state:any) => ({
  ...get(),
  ...slice
}));

const createRootSlice = (set: SetState<any>, get: GetState<any>) => ({
  set,
  setInitialState,
  setStoreSlice,
  ...createAppSlice(set, get),
  ...createLocaleSlice(set, get),
  ...createGlobalsSlice(set, get),
  ...createToySlice(set, get),
  ...createPlayCanvasSlice(set, get),
  ...createGlobalPlayPauseSeekSlice(set, get),
  ...createA11ySlice(set, get),
  ...createTextOverlaySlice(set, get),
  ...createPowerupSlice(set, get),
  ...createGameSlice(set, get),
  ...createSettingsPanelSlice(set, get),
  ...createCameraSlice(set, get)
});

export type CreateStore<T> = UseBoundStore<Write<WithImmer<StoreApi<T extends (infer R) ? R: T>>, any>>
const createStore = <T>():CreateStore<T> => createZustandStore(immer(subscribeWithSelector((
  createRootSlice
))));

export default createStore;
